import * as React from "react";
import { useState } from "react";
import PopoverPopup from "./OEISignOutPopup";
import {ReactComponent as OELogoSvg} from "../logo.svg";
import { ACCOUNTS, ACCOUNTS_PATH, EMPTY, OECENTRAL, OECENTRAL_PATH, SALESFORCE, SALESFORCE_PATH, TEAMS, TEAMS_PATH, USERS_PATH } from "./Constants";

export default function BasicTabs(props) {
 const [clicked,onClicked]=useState(window.location.pathname.replace('/',EMPTY))
   const AccountsTab = () => {
    onClicked(ACCOUNTS)
    props.history.push(ACCOUNTS_PATH);
  };
  const UsersTab = () => {
    onClicked('users')
    props.history.push(USERS_PATH);
  };
  const SalesforcePage = () => {
    onClicked(SALESFORCE)
    props.history.push(SALESFORCE_PATH);
  };
  const OECentralPage = () => {
    onClicked(OECENTRAL)
    props.history.push(OECENTRAL_PATH);
  };
  const TeamsPage = () => {
    onClicked(TEAMS)
    props.history.push(TEAMS_PATH);
  };
  return (
    <>
     <div className="oe-connect__header">
  <header className="oe-connect-header">
  <div className="oe-connect-header__logo">
    <OELogoSvg/>
  </div>
  <div className="oe-connect-header__controls">
    <PopoverPopup/>
  </div>
</header>
<div className="navigation-bar">
  <nav className="navigation-bar__links">
    <ul>
    <li className="navigation-bar__link-wrapper nav-item-account">
        <a onClick={AccountsTab}  className={ `${clicked===ACCOUNTS||clicked===EMPTY?"navigation-bar__link-wrapper--selected":'navigation-bar__link-wrapper'}`}><p className="nav-bar-item">Accounts</p></a>
      </li>
      <li className="navigation-bar__link-wrapper">
        <a onClick={SalesforcePage}  className={ `${clicked===SALESFORCE?"navigation-bar__link-wrapper--selected":'navigation-bar__link-wrapper'}`}><p className="nav-bar-item">Salesforce</p></a>
      </li>      
      <li className="navigation-bar__link-wrapper">
        <a onClick={OECentralPage}  className={ `${clicked===OECENTRAL?"navigation-bar__link-wrapper--selected":'navigation-bar__link-wrapper'}`}><p className="nav-bar-item">OE Central</p></a>
      </li>
      <li className="navigation-bar__link-wrapper">
        <a onClick={TeamsPage} className={ `${clicked===TEAMS?"navigation-bar__link-wrapper--selected":'navigation-bar__link-wrapper'}`}><p className="nav-bar-item">Teams</p></a>
      </li>
      <li className="navigation-bar__link-wrapper">
        <a onClick={UsersTab} id='users'className={ `${clicked==='users'?"navigation-bar__link-wrapper--selected":'navigation-bar__link-wrapper'}`}><p className="nav-bar-item">Users</p></a>
      </li>
      </ul>
    {/* <div class="navigation-bar__current-time">4:02am (GMT -7:00)</div> */}
  </nav>
</div>
</div>
</>
  );
}